import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './Trophy.c.svg';

export const TrophyIcon = withIconWrapper(ReactComponent);
